import { ChangeDetectorRef, Component, forwardRef, ViewEncapsulation, ChangeDetectionStrategy, AfterViewChecked } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { VrTextarea } from './models/vr-textarea';

const VRC_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => VrcTextareaComponent),
  multi: true
};

@Component({
  selector: 'vrc-textarea',
  templateUrl: './vrc-textarea.component.html',
  styleUrls: ['./vrc-textarea.component.scss'],
  providers: [VRC_TEXTAREA_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrcTextareaComponent extends VrTextarea implements AfterViewChecked {

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }
}
